import "./index.css";
import "./utils.css";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./App";

Sentry.init({
  dsn: "https://ff1709c04fa594ed90819561beb671fe@o4507215801548800.ingest.de.sentry.io/4510965419409488",
  sendDefaultPii: true,
  environment: import.meta.env.PUBLIC_SENTRY_ENV,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(<App />);
